import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
  REQUEST_CUSTOMER_FAVORITES,
  FETCH_CUSTOMER_FAVORITES_SUCCESS,
  FETCH_CUSTOMER_FAVORITES_FAILURE,
  SELECT_CUSTOMER_FAVORITES,
  RESET_CURRENT_CUSTOMER_FAVORITES,
  REQUEST_CUSTOMER_FAVORITES_DETAIL,
  FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS,
  FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE,
  REQUEST_ADDING_CUSTOMER_FAVORITE,
  ADD_CUSTOMER_FAVORITE_SUCCESS,
  ADD_CUSTOMER_FAVORITE_FAILURE,
  REQUEST_DELETE_CUSTOMER_FAVORITE,
  DELETE_CUSTOMER_FAVORITE_SUCCESS,
  DELETE_CUSTOMER_FAVORITE_FAILURE,
  REQUEST_CUSTOMERS_WITH_FAVORITES,
  FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS,
  FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE,
  ITEM_IN_LIST,
  CLEAR_IN_LIST_ERROR
} from './type'

import {
    CUSTOMERS_WITH_FAVORITES_URL,
    CUSTOMER_FAVORITE_LIST
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url'

// Inventories Actions

export function fetchCustomerFavorites(Customer_id) {
    return dispatch => {
        dispatch({ type: REQUEST_CUSTOMER_FAVORITES });
        return axios.get(CUSTOMERS_WITH_FAVORITES_URL + Customer_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchCustomerFavoritesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchCustomerFavoritesFailure(err)); 
              }
            });
    }
}

export function fetchCustomerFavoritesSuccess(favorites) {
    return {
        type: FETCH_CUSTOMER_FAVORITES_SUCCESS,
        payload: favorites
    };
}

export function fetchCustomerFavoritesFailure(error) {
    return {
        type: FETCH_CUSTOMER_FAVORITES_FAILURE,
        payload: error
    };
}

export function selectCustomerFavorites(favorites) {
    return {
        type: SELECT_CUSTOMER_FAVORITES,
        payload: favorites
    };
}

export function resetCurrentCustomerFavorites() {
    return {
        type: RESET_CURRENT_CUSTOMER_FAVORITES
    }
}


export function fetchCustomerFavoritesDetail(favorites_id) {
    return dispatch => {
        dispatch({ type: REQUEST_CUSTOMER_FAVORITES_DETAIL });
        return axios.get(CUSTOMERS_WITH_FAVORITES_URL + favorites_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchCustomerFavoritesDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchCustomerFavoritesDetailFailure(err));                     
              }
            });
    }
}

export function fetchCustomerFavoritesDetailSuccess(favoritesDetail) {
    return {
        type: FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS,
        payload: favoritesDetail
    };
}

export function fetchCustomerFavoritesDetailFailure(error) {
    return {
        type: FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE,
        payload: error
    };
}

export function addNewCustomerFavorite(Sales_FavoriteList_Lines, SalesFavoriteList_id) {
  return dispatch => {
      dispatch({ type: REQUEST_ADDING_CUSTOMER_FAVORITE });
      axios.put(CUSTOMER_FAVORITE_LIST + SalesFavoriteList_id,
          {
            Sales_FavoriteList_Lines
          },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(addCustomerFavoriteSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(addCustomerFavoriteFailure(err));                   
            }
          });
  }
}

export function addCustomerFavoriteSuccess() {
    return {
      type: ADD_CUSTOMER_FAVORITE_SUCCESS,
    }
}

export function addCustomerFavoriteFailure(response) {
    return {
      type: ADD_CUSTOMER_FAVORITE_FAILURE,
      payload: response
    }
}

export function deleteCustomerFavorite(Product_id) {
  return dispatch => {
      dispatch({ type: REQUEST_DELETE_CUSTOMER_FAVORITE });
      axios.delete(CUSTOMERS_WITH_FAVORITES_URL + 'line/'+ Product_id,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
        .then(response => {
          dispatch(deleteCustomerFavoriteSuccess());
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(deleteCustomerFavoriteFailure());                 
          }
        });
  }
}

export function deleteCustomerFavoriteSuccess() {
    return {
      type: DELETE_CUSTOMER_FAVORITE_SUCCESS,
    }
}

export function deleteCustomerFavoriteFailure(response) {
    return {
      type: DELETE_CUSTOMER_FAVORITE_FAILURE,
      payload: response
    }
}

export function fetchCustomersWithFavorites() {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
      dispatch({ type: REQUEST_CUSTOMERS_WITH_FAVORITES });
      let url = CUSTOMERS_WITH_FAVORITES_URL
      if (isGGI) {
        url += `?company_id=${selectedCompany.value}`
      }
      axios.get(url,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
        .then(response => {
          dispatch(fetchCustomersWithFavoritesSuccess(response));
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(fetchCustomersWithFavoritesFailure(err));                 
          }
        });
  }
}

export function fetchCustomersWithFavoritesSuccess(response) {
    return {
      type: FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS,
      payload: response
    }
}

export function fetchCustomersWithFavoritesFailure(response) {
    return {
      type: FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE,
      payload: response
    }
}

export function inListError() {
    return {
        type: ITEM_IN_LIST
    }
}

export function clearInListError() {
    return {
        type: CLEAR_IN_LIST_ERROR
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/favoriteList_actions.jsx